import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { M, colors } from '@dashboard-experience/mastodon';
import T from 'components/T';

import { getSections, getArticles, allScreenings } from '../lib/screenings';

// Carbon tag types for the label kinds this internal page used to get from
// Bootstrap's `badge-*`. Mastodon has no yellow tag type, so warning uses its
// status yellow (the one `consider` badges use).
const TAG_TYPE = {
  success: 'green',
  primary: 'blue',
  danger: 'red',
  dark: 'gray',
};

// Carbon paints the gray type on both the tag and its inner label, so the
// yellow has to clear the label's background too or it shows as a ring.
const WarningTag = styled(M.Tag)`
  &.cds--tag {
    background-color: ${colors.uiYellow400};
    color: ${colors.uiGrey800};
  }
  &.cds--tag .cds--tag__label {
    background-color: transparent;
    color: inherit;
  }
`;

const Label = ({ kind, children }) =>
  kind === 'warning' ? (
    <WarningTag type='gray'>{children}</WarningTag>
  ) : (
    <M.Tag type={TAG_TYPE[kind]}>{children}</M.Tag>
  );

Label.propTypes = {
  kind: PropTypes.oneOf([...Object.keys(TAG_TYPE), 'warning']).isRequired,
  children: PropTypes.node.isRequired,
};

const DisputeTree = () => (
  <div className='p-5'>
    <h3>
      <T value='components.disputeTree.title' />
    </h3>
    <ul>
      {getSections(allScreenings()).map(section => {
        const sectionKey =
          section.id != null && section.id !== ''
            ? section.id
            : `section:${section.name}`;
        return (
          <li className='mb-4' key={sectionKey}>
            <strong>{section.name}</strong>{' '}
            {section.labels && section.labels.indexOf('charges') > -1 && (
              <Label kind='success'>
                <T value='components.disputeTree.showCharges' />
              </Label>
            )}
            <ul>
              {getArticles(section.name).map((article, articleIndex) => {
                return (
                  <li
                    className='mb-1'
                    title={article.body}
                    key={
                      article.id != null && article.id !== ''
                        ? article.id
                        : `article:${section.name}:${article.name}:${articleIndex}`
                    }
                  >
                    <a
                      href={
                        `https://checkr.zendesk.com/knowledge/` +
                        `articles/${article.id}/en-us?brand_id=7699428&return_to=%2Fhc%2Fadmin%2Farrange_contents`
                      }
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {article.name}
                    </a>{' '}
                    {article.labels && article.labels.length === 0 && (
                      <Label kind='dark'>
                        <T value='components.disputeTree.showMessage' />
                      </Label>
                    )}
                    {article.labels &&
                      article.labels.indexOf('reason_mvr') > -1 && (
                        <Label kind='warning'>
                          <T value='components.disputeTree.motorVehicleRecord' />
                        </Label>
                      )}
                    {article.labels &&
                      article.labels.indexOf('reason_wrong_person') > -1 && (
                        <Label kind='primary'>
                          <T value='components.disputeTree.wrongPerson' />
                        </Label>
                      )}
                    {article.labels &&
                      article.labels.indexOf('reason_inaccurate') > -1 && (
                        <Label kind='primary'>
                          <T value='components.disputeTree.inaccurateIncompleteInformation' />
                        </Label>
                      )}
                    {article.labels &&
                      article.labels.indexOf('reason_employment') > -1 && (
                        <Label kind='danger'>
                          <T value='components.disputeTree.employment' />
                        </Label>
                      )}
                    {article.labels &&
                      article.labels.indexOf('reason_eviction') > -1 && (
                        <Label kind='danger'>
                          <T value='components.disputeTree.eviction' />
                        </Label>
                      )}
                    {article.labels &&
                      article.labels.indexOf('reason_credit') > -1 && (
                        <Label kind='danger'>
                          <T value='components.disputeTree.credit' />
                        </Label>
                      )}
                  </li>
                );
              })}
            </ul>
          </li>
        );
      })}
    </ul>
  </div>
);

export default DisputeTree;
